import { GetResponse } from '@customTypes/api/IAMAssignedRole';
import { Endpoints, KrakendServiceAPI, ServiceAPI } from '@service/index';
import queryKeys from '@src/queries/keys';

import { useQuery } from '../helper/useQuery';

const useGetIAMAssignedPermission = (enabled = true) =>
  useQuery<GetResponse>(
    [queryKeys.getIAMRoles],
    async () => {
      const isMock = import.meta.env.VITE_ENV !== 'production';
      const endpoint = isMock
        ? Endpoints.IAMAssignedPermissionMock()
        : Endpoints.IAMAssignedPermission();
      const res = isMock
        ? await KrakendServiceAPI.get<void, GetResponse>(endpoint)
        : await ServiceAPI.get<void, GetResponse>(endpoint);
      return res.data;
    },
    {
      cacheTime: 31556952000,
      refetchOnMount: false,
      enabled,
    },
  );

export default useGetIAMAssignedPermission;
